<template>
    <div>
        <div class="base-box base-box__form-info base-box__color-border" v-if="count > limit && count != null">
            Нађено је укупно {{count}} резултата претраге, приказано је првих {{limit}}. Сузите критеријум за претрагу или проширите величину резултата.
        </div>
        <div class="base-box base-box__form-info base-box__color-border" v-else-if="count == 0 && count != null">
            Није пронађен ниједан резултат.
        </div>
        <div class="base-box base-box__form-info base-box__color-border" v-else-if="count <= limit && count != null">
            Нађено је укупно {{count}} резултата претраге.
        </div>
    </div>
</template>

<script>
    
export default {

    name: 'ResultCounter',
    props: ['count', 'limit'],

}

</script>
